const { CHECKBOX_STATES } = require('./ThreeStatesCheckBox');

const { CHECKED, INDETERMINATE, UNCHECKED } = CHECKBOX_STATES;

class Location {
  toggle() {
    this.checked = this.checked === CHECKED ? UNCHECKED : CHECKED;
  }

  setChecked() {
    this.checked = CHECKED;
  }

  setUnchecked() {
    this.checked = UNCHECKED;
  }

  isChecked() {
    return this.checked === CHECKED;
  }

  isUnchecked() {
    return this.checked === undefined || this.checked === UNCHECKED;
  }

  getName() {
    return this.name || this.country;
  }

  isCountry() {
    return 'regions' in this;
  }

  getSlug() {
    return this.slug;
  }

  isOtherCountry() {
    return Location.isRelatedToAnOtherCountry(this.country);
  }

  static isRelatedToAnOtherCountry(location) {
    return location && location.toLowerCase() === 'other';
  }
}

class LocationRegion extends Location {
  /**
   * @param {import('./type').LocationRegion} raw
   */
  constructor(raw) {
    super();
    this.country = raw.country;
    this.name = raw.name;
    this.slug = raw.slug;
    this.nbMissions = raw?.nbMissions;
  }
}

class LocationCountry extends Location {
  /**
   * @param {import('./type').LocationCountry} raw
   */
  constructor(raw) {
    super();
    this.country = raw.country;
    this.slug = raw.slug;
    this.nbMissions = raw?.nbMissions;
    this.regions = raw.regions?.map(r => {
      r.country = raw.country;
      return new LocationRegion(r);
    }) || [];
    this.checked = raw?.checked;
  }

  toggle() {
    super.toggle();
    this.regions.forEach(r => (this.isChecked() ? r.setChecked() : r.setUnchecked()));
  }

  /**
   * A country has no regions if its only region is the country itself.
   */
  hasNoRegions() {
    return this.regions.find(r => r.name === '') !== undefined;
  }

  hasAllRegionsUnchecked() {
    return this.regions.filter(r => r.isUnchecked()).length === this.regions.length;
  }

  hasAllRegionsChecked() {
    const countryRegionsNumber = this.regions.length;
    const countryRegionsNumberChecked = this.regions.reduce((previousRegionsCheckedNumber, currentRegion) => {
      return previousRegionsCheckedNumber + (currentRegion.isChecked() ? 1 : 0);
    }, 0);

    return countryRegionsNumber === countryRegionsNumberChecked;
  }

  getCheckedLocations() {
    return this.regions.filter(r => r.isChecked()).map(r => r || this);
  }

  setChecked() {
    super.setChecked();
    this.regions.forEach(r => r.setChecked());
  }

  setUnchecked() {
    super.setUnchecked();
    this.regions.forEach(r => r.setUnchecked());
  }

  setIndeterminate() {
    this.checked = INDETERMINATE;
  }

  isIndeterminate() {
    return this.checked === INDETERMINATE;
  }
}

module.exports = { LocationCountry, LocationRegion, Location };
